import { useTheme } from 'styled-components';

import { IconProps } from '~types/icon';

export default function User({ width = 22, height = 22, color, ...props }: IconProps) {
  const theme = useTheme();

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 19 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M9.5 10.5C12.4984 10.5 14.9286 8.1498 14.9286 5.25C14.9286 2.3502 12.4984 0 9.5 0C6.50156 0 4.07143 2.3502 4.07143 5.25C4.07143 8.1498 6.50156 10.5 9.5 10.5ZM7.56183 12.4688C3.38438 12.4688 0 15.7418 0 19.7818C0 20.4545 0.564063 21 1.2596 21H17.7404C18.4359 21 19 20.4545 19 19.7818C19 15.7418 15.6156 12.4688 11.4382 12.4688H7.56183Z'
        fill={color || theme.colors.gray800}
      />
    </svg>
  );
}
